import React from 'react';

const LikeIcon = (props) => {
  if (props.user.dislike) {
    return (<i className="fas fa-thumbs-down fa-lg"></i>);
  } else {
    return (<i className="fal fa-thumbs-down fa-lg"></i>);
  }
}
export default LikeIcon;